module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABO0lEQVR4AeyVsUrEQBCGZ1avF67VQt8giXBvYGNpL0juLrWFraKthXXuLgj2lja+wYFJ3kALbQ/sT3f8txncFcKK2OWYH+Zm5/8ShjBr6J9+IXgjTdMb6C3LsvdIvaL/Gu/nsbw/ABXMfCwiF9baPEYicgXPOEmSE8A1PDCqIzQ+tG1bQfcxappmDs8jM4/g1wjBmzj5gH4VgDqP86ovBOvBX5MerBPsR9GPQiegSdRX8VTS4HlhZi+VKV2u7o4kCjw0lDHxhISnwwGlHTw9igKvLNVCMieW2WpNjbo7khD8Y0s5735B672xne7mtnC5q30X1qbbbM6r5RC8xAo8xNLOoaMY4faYwHMA+FKpSDxwXdclGu7QeGmMqWKE3nN4FrgUbsHT8MCofuJGOIW28ZCtSO2g/wxeC2l8AQAA//9KtrgZAAAABklEQVQDAF5z2C3HOdaUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/home/popup-phone.png
// module id = CMFj
// module chunks = 1